import { render, staticRenderFns } from "./AssignV3.vue?vue&type=template&id=23312c68&scoped=true&"
import script from "./AssignV3.vue?vue&type=script&lang=js&"
export * from "./AssignV3.vue?vue&type=script&lang=js&"
import style0 from "./AssignV3.vue?vue&type=style&index=0&id=23312c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23312c68",
  null
  
)

export default component.exports